<!-- 成员账户列表组件 -->
<template>
  <div class="account-list">
    <!-- 筛选表单 -->
    <el-form :inline="true" class="search-form">
      <el-button type="primary" size="small" icon="el-icon-plus" v-waves @click="handleAdd" class="btn-green">新增账户</el-button>
      <el-form-item label="账号" style="margin: 0 20px 0" size="small">
        <el-input v-model="listQuery.username" placeholder="请输入账号" clearable style="width: 180px"></el-input>
      </el-form-item>
      <el-form-item label="手机号" style="margin: 0 20px 0 0" size="small">
        <el-input
          v-model="listQuery.phone_number"
          placeholder="请输入手机号"
          clearable
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" v-waves icon="el-icon-search" class="btn-green">搜索</el-button>
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <!-- <template slot="createID" slot-scope="{ row }">
          <p v-if="!row.createID">/</p>
          <el-tag effect="dark" size="mini" v-else-if="row.createID === 1">超级管理员创建</el-tag>
          <el-tag type="success" effect="dark" size="mini" v-else>{{ row.createID }}</el-tag>
        </template>-->

        <!-- <template slot="store_id" slot-scope="{ row }">
          <StoreToString :store_id="String(row.store_id)" />
        </template>-->

        <template slot="role_name" slot-scope="{ row }">
          <el-tag effect="dark" size="mini" v-if="row.role_name == '超级管理员'">{{ row.role_name }}</el-tag>
          <el-tag type="success" effect="dark" size="mini" v-else>{{ row.role_name }}</el-tag>
        </template>

        <template slot="error" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="!row.error">无异常</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>{{ row.error }}次</el-tag>
        </template>

        <template slot="openid" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.openid">已绑定</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>未绑定</el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" class="text-green">编辑</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
              v-if="row.id!==1"
             class="text-red">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 账户表单抽屉 -->
    <el-drawer
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      direction="rtl"
      size="600px"
    >
      <div style="padding: 20px;">
        <el-form ref="form" :model="dialogForm" label-width="90px">
          <el-form-item label="账号状态:" required>
            <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%">
              <div v-for="(item, index) in statusList" :key="index">
                <el-option :label="item.name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="到期时间" required>
            <el-input clearable v-model="dialogForm.vipDate" placeholder="请输入"></el-input>
          </el-form-item>-->
          <el-form-item label="账号角色:" required>
            <el-select v-model="dialogForm.role_id" placeholder="请选择" style="width: 100%" clearable>
              <div v-for="(item, index) in authGroupList" :key="index">
                <el-option :label="item.role_name" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="账号" required>
            <el-input clearable v-model="dialogForm.username" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="密码" required>
            <el-input
              clearable
              v-model="dialogForm.password"
              placeholder="输入密码自动md5加密"
              :disabled="!!dialogForm.id"
            ></el-input>
            <el-button
              v-if="dialogForm.id"
              type="warning"
              size="mini"
              style="margin-top: 5px;"
              @click="handleResetPassword"
            >重置密码为123456</el-button>
          </el-form-item>
          <el-form-item label="昵称" required>
            <el-input clearable v-model="dialogForm.alias_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input clearable v-model="dialogForm.phone_number"></el-input>
          </el-form-item>
          <!-- <el-form-item label="微信绑定">
            <el-input
              clearable
              v-model="dialogForm.accountID"
              placeholder="请输入accountID"
            ></el-input>
          </el-form-item>-->
          <el-form-item label="异常登录" required v-if="dialogName !== '创建账号'">
            <el-input clearable v-model="dialogForm.error" placeholder="请输入次数,默认为0" type="number"></el-input>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="save">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ElTable from "@/components/elTable/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import listHeader from "../listHeader";
import {
  selectApi as selectAdmin,
  deleteApi as deleteAdmin,
  updateApi as updateAdmin,
  addApi as addAdmin
} from "@/services/systemPage/admin_user.js";
import { selectApi as selectAuthGroup } from "@/services/systemPage/admin_role.js";
export default {
  name: "AccountList",
  components: {
    ElTable,
    StoreToString
  },
  props: {
    selectedRoleId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        role_id: null
      },
      tableData: [],
      statusList: [
        { id: 0, name: "正常" },
        { id: 1, name: "暂停使用" }
      ],
      authGroupList: [],
      dialogName: "",
      dialogVisible: false,
      dialogForm: {
        id: null,
      },
      password: ""
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo"])
  },
  watch: {
    selectedRoleId: {
      handler(newVal) {
        this.listQuery.role_id = newVal;
        this.listQuery.pageNumber = 1;
        this.getListData();
      },
      immediate: true
    }
  },
  created() {
    this.getGroup();
    // 监听角色更新事件
    this.$root.$on("role-list-updated", this.getGroup);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off("role-list-updated", this.getGroup);
  },
  methods: {
    /* 获取角色组 */
    getGroup() {
      selectAuthGroup().then(res => {
        if (res.code === 200) {
          this.authGroupList = res.data;
        }
      });
    },

    /* 获取列表数据 */
    async getListData() {
      this.loading = true;
      const { data, code, count } = await selectAdmin(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },

    /* 搜索按钮 */
    async search() {
      this.getListData();
    },

    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },

    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建账号";
      // 如果父组件有选中角色，则默认选中该角色
      this.dialogForm = {
        error: 0,
        role_id: this.selectedRoleId || null
      };
      this.password = "";
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑账号";
      this.password = row.password;
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.role_id ||
        !this.dialogForm.username ||
        !this.dialogForm.password ||
        !this.dialogForm.alias_name ||
        !this.dialogForm.phone_number ||
        (!this.dialogForm.error && this.dialogForm.error !== 0)
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      let formData = JSON.parse(JSON.stringify(this.dialogForm));
      if (!formData?.id) {
        addAdmin({
          ...formData,
          createID: this.userInfo.id
        }).then(res => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogVisible = false;
          }
        });
        return;
      }
      delete formData.password; // 删除不可修改字段
      updateAdmin({
        ...formData
      }).then(res => {
        if (res.code === 200) {
          this.getListData();
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
          this.dialogVisible = false;
        }
      });
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteAdmin({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 重置密码 */
    handleResetPassword() {
      this.$confirm("确定要将此账号的密码重置为 123456 吗?", "重置密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 调用更新接口，密码字段传入 123456
          updateAdmin({
            id: this.dialogForm.id,
            password: "123456"
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "密码重置成功!"
                });
                // 更新表单中的密码显示
                this.dialogForm.password = "密码重置成功";
              }
            })
            .catch(err => {
              this.$message.error("密码重置失败");
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.account-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 搜索表单 */
.search-form {
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}

/* 表格列表 */
.tableList {
  flex: 1;
  overflow: hidden;
  padding: 15px 20px;
}

.operation {
  display: flex;
  gap: 5px;
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}
</style>
